export default "__VITE_ASSET__2d9aa329__"